import { RecaptchaSettings, } from 'ng-recaptcha';
const ɵ0 = {
    siteKey: '6Led2LUUAAAAAEp94Cec3sUMtDAMbvgkUXJxBKrg',
};
export class SharedModule {
}
export { ɵ0 };
